import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
// styles.css подключается из tailwind.css слоем legacy — см. комментарий там.
import './tailwind.css';
import { registerServiceWorker } from './lib/pwa.ts';

const root = document.getElementById('root');
if (!root) throw new Error('Не найден корневой элемент #root');

registerServiceWorker();

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
